var map = {
	"./black/join2.png": "7eNf",
	"./blue/join2.png": "rbpQ",
	"./white/join2.png": "FBIt"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UqsB";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/join2\.png$
// module id = UqsB
// module chunks = 24